var VerificationCodeModule = /** @class */ (function () {
    function VerificationCodeModule() {
    }
    return VerificationCodeModule;
}());
export { VerificationCodeModule };
